import { RulesTable, QTable, QTableBody, QTableRow, QTableCell, QSearchBar } from '@kw/quokka-ui';
import { Box } from '@mui/material';
import { useState, useMemo } from 'react';
import { filterByQuery as filterBySearchQuery } from '../utils/filterHelper';
import { useLocalStorage } from '../../../../utils/useLocalStorage';
import { getEvidencesCallbackWithToken, removeDuplicateRuleSummaries } from '../utils/dopplerUtil';

export const LibrariesAndFrameworks = ({ ruleSummaries, analysisId }) => {
  const [accessToken = ''] = useLocalStorage('accessToken', '');

  const librariesAndFrameworksTable = useMemo(() => {
    const uniqueRuleSummaries = removeDuplicateRuleSummaries(ruleSummaries) || [];
    return (
      <RulesTable
        ruleSummaries={uniqueRuleSummaries}
        uuid={analysisId}
        getEvidencesCallback={getEvidencesCallbackWithToken(accessToken)}
        instance="QScout"
        searchConfig={['rule.shortDescription.text', 'rule.name']}
      />
    );
  }, [ruleSummaries, analysisId, accessToken]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100vh' }}>
      <Box
        sx={{
          overflowY: 'auto',
        }}
      >
        {librariesAndFrameworksTable}
      </Box>
    </Box>
  );
};
